import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import FreeloadingForm from "./FreeloadingForm";

import {
  useGetFreeloadingDetailQuery,
  useUpdateFreeloadingMutation,
} from "store/services/freeloadingApi";

import { useAppMeta } from "hooks";

const FreeloadingEditScreen = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Freeloading", path: "/app/crm/shipment-loading/list" },
    { title: "Edit Freeloading" },
  ];

  // RTK Query
  const {
    data: freeloadingDetail,
    isLoading: isFetching,
    error,
  } = useGetFreeloadingDetailQuery(id);

  const [updateFreeloading, { isLoading: isUpdating }] = useUpdateFreeloadingMutation();

  // Update handler
  const handleUpdateFreeloading = async (data) => {
    const payload = { id, ...data };
    try {
      await updateFreeloading(payload).unwrap();
      toast.success("Freeloading successfully updated!");
      navigate(`/app/crm/shipment-loading/${id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't update freeloading!"
      );
    }
  };

  useAppMeta("Edit Freeloading");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={isFetching || isUpdating}
    >
      <BreadcrumbLayout.Error error={error} />
      <BreadcrumbLayout.Paper>
        <FreeloadingForm
          isBusy={isFetching || isUpdating}
          freeloadingDetail={freeloadingDetail}
          onSubmit={handleUpdateFreeloading}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default FreeloadingEditScreen;